// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const container = (overlay.isConnected ? overlay : image).getBoundingClientRect();
  const imageRatio = image.naturalWidth / image.naturalHeight;
  const containerRatio = container.width / container.height;

  let renderedWidth = container.width;
  let renderedHeight = container.height;
  let horizontalOffset = 0;
  let verticalOffset = 0;

  if (imageRatio > containerRatio) {
    renderedHeight = container.width / imageRatio;
    verticalOffset = (container.height - renderedHeight) / 2;
  } else {
    renderedWidth = container.height * imageRatio;
    horizontalOffset = (container.width - renderedWidth) / 2;
  }

  const xPosition = Math.min(
    Math.max(event.clientX - container.left - horizontalOffset, 0),
    renderedWidth
  );
  const yPosition = Math.min(
    Math.max(event.clientY - container.top - verticalOffset, 0),
    renderedHeight
  );
  const xPercent = `${(xPosition / renderedWidth) * 100}%`;
  const yPercent = `${(yPosition / renderedHeight) * 100}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${renderedWidth * zoomRatio}px ${renderedHeight * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, overlay, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();

  return overlay;
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      const overlay = magnify(image, zoomRatio);
      moveWithHover(image, overlay, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
